import { useEffect, useState } from 'react';
import { Loader2, TrendingDown } from 'lucide-react';
import { api } from '../api';
import Ayuda from '../ui/Ayuda';
import NotaExplicativa from '../ui/NotaExplicativa';

/* =====================================================================
   Sugerencias de compra · TC-25 (el mínimo sugerido) y TC-26 (la señal)
   =====================================================================
   Dos listas que ya existían como rutas: cuánto mínimo sugiere TEGO por
   producto según lo que sale, y qué productos salen mucho más de lo que
   entran. La segunda, desde hoy, también avisa sola.
   ===================================================================== */
export default function Sugerencias() {
  const [sug, setSug] = useState(null);
  const [senales, setSenales] = useState([]);
  const [error, setError] = useState('');
  const [soloDistintos, setSoloDistintos] = useState(true);
  useEffect(() => {
    let vivo = true;
    Promise.all([api.get('/umbrales'), api.get('/umbrales/senales')])
      .then(([s, n]) => { if (vivo) { setSug(s); setSenales(n); setError(''); } })
      .catch((e) => { if (vivo) setError(e.message); });
    return () => { vivo = false; };
  }, []);
  if (error && !sug) return <p className="p-4 text-sm text-red-700">{error}</p>;
  if (!sug) {
    return (
      <p className="flex items-center gap-2 p-4 text-sm text-gray-500">
        <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" /> Calculando…
      </p>
    );
  }
  const filas = soloDistintos ? sug.filter((s) => s.minimo_sugerido != null && Math.abs(s.diferencia || 0) >= 1) : sug;
  return (
    <div className="flex max-w-5xl flex-col gap-6 p-4">
      <header>
        <h1 className="text-xl font-semibold text-gray-900">Sugerencias de compra</h1>
        <p className="text-gray-600">Cuánto mínimo conviene tener de cada producto según lo que sale, y qué sale de más.</p>
        <Ayuda id="terminal.umbrales.pantalla" />
      </header>

      <section className="rounded-xl border border-red-200 p-4">
        <h2 className="flex items-center gap-2 font-semibold text-gray-900"><TrendingDown className="h-4 w-4 text-red-600" aria-hidden="true" /> Sale de más · {senales.length}</h2>
        <Ayuda id="terminal.umbrales.senal" />
        {senales.length === 0 ? <p className="text-sm text-gray-600">Ningún producto lleva dos semanas saliendo más de lo que entra.</p> : (
          <ul className="mt-2 divide-y divide-gray-100 text-sm">{senales.map((s) => (
            <li key={s.sku} className="py-2"><span className="font-medium">{s.producto}</span> <span className="font-mono text-gray-500">{s.sku}</span><p className="text-gray-700">{s.mensaje}</p></li>))}</ul>
        )}
      </section>

      <section className="rounded-xl border border-gray-200 p-4">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <h2 className="font-semibold text-gray-900">Mínimo sugerido por producto</h2>
          <label className="text-sm text-gray-700"><input type="checkbox" checked={soloDistintos} onChange={(e) => setSoloDistintos(e.target.checked)} className="mr-1" />Solo los que cambian</label>
        </div>
        {filas.length === 0 ? (
          <NotaExplicativa titulo="Nada que sugerir">Con menos de cuatro semanas de salidas TEGO no sugiere: la media no sería de nadie. Cuando haya historia, aquí aparece cuánto mínimo tener.</NotaExplicativa>
        ) : (
          <div className="overflow-x-auto"><table className="mt-2 min-w-full text-sm">
            <thead><tr className="text-left text-gray-500"><th className="pr-3">Producto</th><th className="pr-3">Mínimo hoy</th><th className="pr-3">Sale al día</th><th className="pr-3">Reabasto</th><th className="pr-3">Sugerido</th><th className="pr-3">Diferencia</th></tr></thead>
            <tbody>{filas.map((s) => (
              <tr key={s.sku}>
                <td className="pr-3"><span className="font-medium">{s.producto}</span> <span className="font-mono text-xs text-gray-500">{s.sku}</span></td>
                <td className="pr-3 tabular-nums">{s.stock_minimo_actual}</td>
                <td className="pr-3 tabular-nums">{s.sin_datos ? <span className="text-xs text-gray-500">{s.sin_datos}</span> : s.media_diaria}</td>
                <td className="pr-3">{s.dias_reabasto != null ? `${s.dias_reabasto} días` : '—'}</td>
                <td className="pr-3 tabular-nums font-semibold">{s.minimo_sugerido ?? '—'}</td>
                <td className={`pr-3 tabular-nums ${(s.diferencia || 0) > 0 ? 'text-amber-700' : 'text-gray-600'}`}>{s.diferencia == null ? '—' : `${s.diferencia > 0 ? '+' : ''}${s.diferencia}`}</td>
              </tr>))}</tbody>
          </table></div>
        )}
        <p className="mt-2 text-xs text-gray-500">El mínimo se cambia en la ficha del producto; aquí solo se sugiere.</p>
      </section>
    </div>
  );
}
